import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { CREATE_SECURITY_URL, SET_SECURITY_URL_LIST, REQUEST_SECURITY_URL_LIST, REQUEST_DELETE_SECURITY_URL } from './constants'
import SecurityUrlClient from '../../apiClient/SecurityUrlClient'
import {setSecurityUrlList} from "../SecurityUrl/actions";
import {message} from "antd";

const securityUrlClient = new SecurityUrlClient()

function* create({ payload: { url } }) {
    try {
        const securityUrl = yield call(securityUrlClient.postSecurityUrl, url)
        yield getAll({ payload: { page: 1 } })
        message.success('Security url successfully created')
    } catch (e) {
        console.warn(e)
    }
}

function* deleteSecurityurl ({ payload: { security_url_id } }) {
    try {
        const securityUrl = yield call(securityUrlClient.deleteSecurityUrl, security_url_id)
        const page = yield select(({ securityurls }) => securityurls.pagination.page_number)
        yield getAll({ payload: { page: 1 } })
    } catch (e) {
        console.warn(e)
    }
}

function* getAll({ payload: { page } }){
    try {
        const { security_urls, pagination } = yield call(securityUrlClient.getAll, page)
        yield put(setSecurityUrlList({payload: {security_urls, pagination}}))
    } catch (e) {
        console.warn(e)
    }
}



export default function* appSagas() {
    yield all([
        takeEvery(CREATE_SECURITY_URL, create),
        takeEvery(REQUEST_SECURITY_URL_LIST, getAll),
        takeEvery(REQUEST_DELETE_SECURITY_URL, deleteSecurityurl)
    ])
}
